import React, { Component } from 'react';
import style from '../share/pageUpdate.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';
//import MultipleCheckedWithLabel from '../../components/MultipleCheckedWithLabel.js';
import * as utils from '../../Utils.js';
import axios from 'axios';


class RoomCodeUpdate extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            dataObject: null,
            userObject: null,
            //companyId: this.props.companyId,
            validateObject: null,
            loading: true,
            file: null

        };

        //alert("CompanyUserControlUpdate");

    }
    componentDidMount() {
        this.callGetData();
    }
    callGetData() {



        //let appState = this.props.appState;

        //console.log(appState);

        let userObject = this.props.appState.userObject;
        let token = userObject.Token;




        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetRoomCodeData";
        let data = {
            Id: this.props.Id,
            CompanyId: userObject.companyId
        };


        utils.callPost(url, token, data, this.callGetDataCallBack);

        this.setState({
            loading: true
        })

    }
    callGetDataCallBack = (res) => {
        let data = res.Data;
        this.setState({
            dataObject: { ...data.dataObject },
            validateObject: { ...data.validateObject },
            loading: false
        })
    }
    callSetData() {

        if (this.props.method === "Create") {
            let userObject = this.props.appState.userObject;
            let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/CreateRoomCode";
            let data = { ...this.state.dataObject };
            //let file = document.getElementById("image-file").files[0];

            const formData = new FormData();
            formData.append('file', this.state.file);
            formData.append('code', data.code);
            formData.append('sort', data.sort);
            formData.append('guest', data.guest);
            formData.append('roomname_en', data.roomname_en);
            formData.append('roomname_th', data.roomname_th);


            let token = this.props.appState.userObject.Token;
            axios.post(url, formData, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'multipart/form-data'

                }
            })
                .then(response => {
                    let data = response.data;
                    if (data.Success === false && data.Message === "Authorization failed.") {
                        window.localStorage.removeItem("userObject1");
                        window.location.reload();
                    }
                    this.callSetDataCallBack(response.data);
                })
                .catch(err => {
                    console.error(err)
                })

            this.setState({
                isLoading: true
            });
        }
        else {
            let userObject = this.props.appState.userObject;
            let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/UpdateRoomCode";
            let data = { ...this.state.dataObject };
            //let file = document.getElementById("image-file").files[0];

            const formData = new FormData();
            formData.append('file', this.state.file);
            formData.append('code', data.code);
            formData.append('sort', data.sort);
            formData.append('guest', data.guest);
            formData.append('roomname_en', data.roomname_en);
            formData.append('roomname_th', data.roomname_th);
            formData.append('Id', data.Id);

            let token = this.props.appState.userObject.Token;
            axios.post(url, formData, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'multipart/form-data'

                }
            })
                .then(response => {
                    let data = response.data;
                    if (data.Success === false && data.Message === "Authorization failed.") {
                        window.localStorage.removeItem("userObject1");
                        window.location.reload();
                    }
                    this.callSetDataCallBack(response.data);
                })
                .catch(err => {
                    console.error(err)
                })

            this.setState({
                isLoading: true
            });
        }
    }
    callSetDataCallBack = (data) => {

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }


    callDeleteData() {
        let userObject = this.props.appState.userObject;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/DeleteRoomCode";
        let data = { ...this.state.dataObject };

        let token = userObject.Token;

        utils.callPost(url, token, data, this.callDeleteDataCallBack);


        // axios
        //     .post(url, data, {
        //         headers: {
        //             'Authorization': userObject.Token
        //         }
        //     })
        //     .then(response => {
        //         this.callDeleteDataCallBack(response.data);
        //     })
        //     .catch(err => {
        //         console.error(err)
        //     })

        this.setState({
            loading: true
        })
    }
    callDeleteDataCallBack = (data) => {
        //console.log(data);

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }






    handleChange = (e) => {
        //alert("change");

        //console.log(e);

        //alert(e.target.name);
        let dataObject = { ...this.state.dataObject };

        //if (e.target.name === "HotelCode") dataObject.HotelCode = e.target.value;
        //if (e.target.name === "AllowOutPolicy ") dataObject.AllowOutPolicy  = e.target.checked;

        //if (e.target.name === "CompanyName") dataObject.CompanyName  = e.target.value;

        //alert("call");

        if (e.target.name === "Enable") {
            dataObject.IsEnable = e.target.checked;
        }
        // else if (e.target.name === "IsApprover") {
        //     dataObject.IsApprover = e.target.checked;
        // }




        else if (e.target.name !== "") {
            //alert(e.target.name);
            dataObject[e.target.name] = e.target.value
            //console.log("debug dataobject");
            //console.log(dataObject);
        }





        //if (e.target.name === "RequireApprover") dataObject.RequireApprover = e.target.checked;

        //if (e.target.name === "IsBudgetEnable") dataObject.IsBudgetEnable = e.target.checked;

        // if (e.target.name === "Budget") {

        //     if(utils.isNumeric(e.target.value)){
        //         dataObject.Budget = e.target.value;
        //     }
        //     if(e.target.value === ""){
        //         dataObject.Budget = e.target.value;
        //     }






        //     //alert("Bugget");
        //     //dataObject.Budget = e.target.value;
        // }






        //if (e.target.name === "Name") dataObject.Name = e.target.value;

        this.setState({
            dataObject: dataObject,
        })
    }
    handleClick = (e) => {
        //alert("Update");
        //console.log(e);
        if (e.target.name === "Create") {
            this.callSetData();
        }
        if (e.target.name === "Delete") {
            this.callDeleteData();
        }
        if (e.target.name === "Update") {
            this.callSetData();
        }
    }

    selectFile = () => {
        //alert("select fiel");
        let self = this;
        let id = document.getElementById("image-file");
        id.onchange = function (e) {
            let c_id = document.getElementById("image-file").files[0];
            //this.state.fileList.push(c_id);
            document.getElementById("image-file").value = null;

            let dataObject = self.state.dataObject;
            dataObject.filename = c_id.name;
            //console.log(this.state.fileList);
            self.setState({
                dataObject: dataObject,
                file: c_id
            });

            //self.storeFile(c_id);

        }
        id.click();
    }
    // storeFile = (fileData) => {
    //     let formData = new FormData();
    //     formData.append("file", fileData);

    //     let token = this.props.appState.userObject.Token;
    //     let url = process.env.REACT_APP_API_END_POINT + "/api/corp/fileupload";

    //     axios.post(url, formData, {
    //         headers: {
    //             'Authorization': token,
    //             'Content-Type': 'multipart/form-data'

    //         }
    //     })
    //         .then(response => {
    //             let data = response.data;
    //             if (data.Success === false && data.Message === "Authorization failed.") {
    //                 window.localStorage.removeItem("userObject1");
    //                 window.location.reload();
    //             }
    //             this.storeFileCallBack(response.data);
    //         })
    //         .catch(err => {
    //             console.error(err)
    //         })

    //     this.setState({
    //         isLoading: true
    //     });


    //}

    // renderNameInput(dataObject, validateObject) {
    //     let item = [];

    //     //console.log("debug");
    //     //console.log(dataObject);

    //     for (let i = 0; i < dataObject.HotelNameList.length; i++) {
    //         let label = "Hotel Name (" + dataObject.HotelNameList[i].LanguageCode + ")";
    //         item.push(
    //             <div className={style.sectionInput} key={i}>
    //                 <TextBoxWithLabel name="Name" id={i} key={i} label={label} value={dataObject.HotelNameList[i].Name} errorMessage={validateObject.HotelNameList[i].Name} onChange={this.handleChange} />
    //             </div>
    //         );
    //     }
    //     return item;
    // }
    render() {
        let result = [];
        let dataObject = this.state.dataObject;
        let validateObject = this.state.validateObject;

        //let userObject = this.props.appState.userObject;

        if (dataObject != null) {
            //let rowNameInput = this.renderNameInput(dataObject, validateObject);
            //alert(this.props.Id);

            //console.log(dataObject);



            result = (
                <div className={style.createArea}>
                    <BackDropLoading show={this.state.loading} />
                    <div className={style.contentBox}>

                        {this.props.method === "Create" &&
                            <div className={style.contentTitle}>Create RoomCode</div>
                        }
                        {this.props.method === "Edit" &&
                            <div className={style.contentTitle}>Edit RoomCode</div>
                        }
                        {this.props.method === "Delete" &&
                            <div className={style.contentTitle}>Delete RoomCode</div>
                        }






                        <div className={style.line}></div>


                        {/* <div className={style.rowInput}>
                            <CheckBoxWithLabel name="Enable" label="Active" value={dataObject.IsEnable} errorMessage="" onChange={this.handleChange} />
                        </div> */}

                        {/* <div className={style.rowInput}>
                            <CheckBoxWithLabel name="IsApprover" label="IsApprover" value={dataObject.IsApprover} errorMessage="" onChange={this.handleChange} />
                        </div> */}




                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="code" label="code*" value={dataObject.code} errorMessage={validateObject.code} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="roomname_en" label="roomname_en*" value={dataObject.roomname_en} errorMessage={validateObject.roomname_en} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="roomname_th" label="roomname_th*" value={dataObject.roomname_th} errorMessage={validateObject.roomname_th} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="guest" label="guest*" value={dataObject.guest} errorMessage={validateObject.guest} onChange={this.handleChange} />
                        </div>
                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="sort" label="sort*" value={dataObject.sort} errorMessage={validateObject.sort} onChange={this.handleChange} />
                        </div>

                        {this.props.method !== "Delete" &&
                            <div>
                                <div className={style.sectionInput}>
                                    <TextBoxWithLabel name="filename" label="filename*" value={dataObject.filename} errorMessage={validateObject.filename} readOnly={true} onChange={this.handleChange} />
                                </div>
                                <div className={style.sectionInput}>
                                    <DefaultBtn label="Browse" onClick={this.selectFile} name="Browse" type="primary" />

                                    <input className={style.image_file} id="image-file" type="file" />
                                </div>
                            </div>
                        }






                        <div className={style.btnRow}>
                            <div className={style.btnRowCenter}>


                                {this.props.method === "Create" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Create" onClick={this.handleClick} name="Create" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Edit" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Delete" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Delete" onClick={this.handleClick} name="Delete" type="danger" />
                                    </div>
                                }
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Back" onClick={this.props.onClose} name="Back" type="default" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            );
        }
        return result;
    }
}
export default RoomCodeUpdate;